<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '280px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false" >
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('选择人员')" prop="userId">
                <!-- <a-select placeholder="请选择人员" v-model="model.userId">
                  <a-select-option :value="item.userId" v-for="item in personnelList">{{item.userName}}</a-select-option>
                </a-select> -->
                <j-select-user-by-dep v-model="model.userId" :isGg="true" :multi="false" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('人员电话')" prop="userPhone">
                <a-input v-model="model.userPhone"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import JSelectUserByDep from "@/components/jeecgbiz/JSelectUserByDep"
  export default {
    // mixins: [JeecgListMixin],
    name: 'deviceModal',
    components: {
      JSelectUserByDep
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-engineering/inspection/inspectionUser/add",
          edit: "/jeecg-engineering/inspection/inspectionUser/edit",
          queryById: "/jeecg-engineering/inspection/inspectionUser/queryById",
          userList: "/sys/user/list",
        },
        personnelList: [],
      }
    },
    computed: {
      validatorRules() {
        return {
          userId: [{required:true,message:this.$t('请选择人员'),trigger:'change'}],
        }
      },
    },
    watch:{
      'model.userId':{
        handler(val){
          let params = this.personnelList.find(per=>per.userId == val);
          if(params){
            this.model.userName = params.realName;
            this.model.userPhone = params.userPhone;
          }
        }
      }
    },
    methods: {
      getPersonnelList(){
        this.personnelList = [];
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.personnelList.push({
                userId: item.id,
                userName: item.username,
                realName: item.realname,
                userPhone: item.phone
              });
            });
          }
        });
      },
      add() {
        this.visible = true;
        this.model = {};
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        });
        this.getPersonnelList();
      },
      edit(record) {
        this.visible = true;
        this.getPersonnelList();
        this.model = JSON.parse(JSON.stringify(record));
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>